export default "/img/BI.9fe55bf01bc3ba8768478a2de780fe11.png";